import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import AppAppBar from "./components/AppAppBar";
import Hero from "./components/Hero";
import LogoCollection from "./components/LogoCollection";
import Highlights from "./components/Highlights";
import Pricing from "./components/Pricing";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import AppTheme from "./components/AppTheme";
import { useColorScheme } from "@mui/material";

function App(props: { disableCustomTheme?: boolean }) {
	const { mode, systemMode, setMode } = useColorScheme();

	React.useEffect(() => {
		if (mode !== "dark") {
			setMode("dark");
		}
	}, [mode]);
	return (
		<AppTheme {...props}>
			<CssBaseline enableColorScheme />

			<AppAppBar notHomePage={false} />
			<Hero />
			<div>
				{/* <LogoCollection /> */}
				<Features />
				<Divider />
				{/* <Testimonials />
				<Divider /> */}
				<Highlights />
				<Divider />
				<Pricing />
				<Divider />
				<FAQ />
				<Divider />
				<Footer />
			</div>
		</AppTheme>
	);
}

export default App;
